import Api from 'api/v2/Api';
import axios from 'axios';

class CasesApi extends Api {
  /**
   * @param  {Object} payload [subject, description, firstname, lastname, attachments]
   */
  postContactSupport(payload) {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (key !== 'attachment') {
        formData.append(key, payload[key]);
      } else {
        payload[key].forEach((file) => {
          formData.append(key, file);
        });
      }
    });

    return this.initialize()
      .then(() => axios.post('/api/cases', formData, { headers: { 'Content-Type': 'multipart/form-data' } }));
  }
}

export default new CasesApi();
